import React from 'react'
import {
  Modal as CoreModal,
  Spin,
  ModalProps,
  Typography,
  Row,
} from 'antd'
import { QueryStatus } from '@reduxjs/toolkit/query'
import {
  ModalCloseIco,
  ModalErrorIco,
  ModalSuccessIco,
} from '@modules/CustomIcons'
import ButtonGlobal from '@shared/Button'
import { t } from 'i18next'
import BeatLoader from '@shared/BeatLoader/BeatLoader'

export type ModalStatus = QueryStatus | ''
export type ReusableModalProps = ModalProps & {
  status?: ModalStatus
  message?: string
  onClose?: () => void
  title?: React.ReactNode
  children?: React.ReactNode
}

const renderOverlayByStatus = (status: ModalStatus) => {
  switch (status) {
    case QueryStatus.pending:
      return (
      <BeatLoader />
      )
    case QueryStatus.rejected:
      return <ModalErrorIco />
    case QueryStatus.fulfilled:
      return <ModalSuccessIco />
    case QueryStatus.uninitialized:
    default:
      return null
  }
}

export const Modal: React.FC<ReusableModalProps> = ({
  status = '',
  message = '',
  onClose,
  title = '',
  children,
  width,
  footer,
  ...rest
}) => {
  return (
    <CoreModal
      {...rest}
      width={[QueryStatus.pending, QueryStatus.rejected, QueryStatus.fulfilled].includes(status) ? 500 : width}
      closeIcon={<ModalCloseIco />}
      title={status === QueryStatus.rejected ? t('common.attention') : title}
      onCancel={onClose}
      footer={footer ? footer : null}
      centered
    >
      <div style={{ position: 'relative', overflow: 'hidden', minHeight: 200 }}>
        {children}
        {status && status !== QueryStatus.uninitialized && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255,255,255)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1,
            }}
          >
            <Row
              align="middle"
              justify="center"
              style={{ flexDirection: 'column', height: '100%', gap: 15 }}
            >
              {renderOverlayByStatus(status)}
              {message && status !== QueryStatus.pending && (
                <Typography.Text style={{ fontSize: 17, color: 'gray' }}>
                  {message}
                </Typography.Text>
              )}
              { [QueryStatus.fulfilled, QueryStatus.rejected].includes(status) && (
                <ButtonGlobal onClick={onClose}>{t('common.close')}</ButtonGlobal>
              )}
            </Row>
          </div>
        )}
      </div>
    </CoreModal>
  )
}
